import { createClient } from '@connectrpc/connect'
import { createConnectTransport } from '@connectrpc/connect-web'
import { AiChatEvent, AiChatEventPayload } from 'poc-ai-biz-irdb_domain-model'
import { AiChatService } from '../../../../../proto/_gen/aiChat_connect'
import { SendMessageRequest } from '../../../../../proto/_gen/aiChat_pb'
import { authenticator } from '../../../../pages/_shared/authService'
import { convertClientInfoToProto } from '../../../../../proto/converters'

declare var IRDB_BACKEND_API_URL: string | undefined

type ClientInfo = Extract<AiChatEventPayload, { type: 'clientInfo' }>

export const useSendMessage = () => {
  const backendApiUrl = IRDB_BACKEND_API_URL
  if (!backendApiUrl) {
    throw new Error('The IRDB_BACKEND_API_URL environment variable is not set')
  }

  const transport = createConnectTransport({
    baseUrl: backendApiUrl,
    interceptors: [authenticator],
  })
  const client = createClient(AiChatService, transport)

  return async (request: { sessionId: string; userId: string; content: string; clientInfo: ClientInfo | undefined }) => {
    // domain-model型をProtobuf型に変換
    const protoRequest = new SendMessageRequest({
      sessionId: request.sessionId,
      userId: request.userId,
      content: request.content,
      clientInfo: request.clientInfo ? convertClientInfoToProto(request.clientInfo) : undefined,
    })

    const response = await client.sendMessage(protoRequest)

    if (response.error) {
      throw new Error(response.error.message || 'Unknown error occurred during message send')
    }

    if (!response.eventId) {
      throw new Error('No eventId returned from server')
    }

    // eventIdを返す（実際のメッセージイベントはsubscribeAiChatEventsで受信）
    return {
      eventId: response.eventId,
    }
  }
}
